import { render, staticRenderFns } from "./MyOrderSide.vue?vue&type=template&id=2bf0c6c3&scoped=true&"
import script from "./MyOrderSide.vue?vue&type=script&lang=js&"
export * from "./MyOrderSide.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderSide.vue?vue&type=style&index=0&id=2bf0c6c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0c6c3",
  null
  
)

export default component.exports